@import '~style-sheet-helpers/core.less';
@import (reference) '../../../settings-page.module.less';

@import '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.settings-secure-text {
  margin-bottom: @space-12;
}

.settings-no-account-owner {
  max-width: 808px;
}

.settings-api-section {
  max-width: 808px;
  border-radius: 8px;
  margin-bottom: @space-32;
  background-color: var(--grey-000);
  border: 1px solid var(--grey-300);
}

.settings-api-selector-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.settings-api-selector {
  flex: 1;
  max-width: 224px;
}

.settings-api-plan-upgrade-modal-styles {
  margin-bottom: @space-24;
}
